import { safeDecodeURIComponent } from '@mygpt/app';

export const getUrlHashParams = () => {
  const hashParams: any = {};
  let e;
  const a = /\+/g, // Regex for replacing addition symbol with a space
    r = /([^&;=]+)=?([^&;]*)/g,
    d = function (s: any) {
      return safeDecodeURIComponent(s.replace(a, ' '));
    },
    q = (window.location.hash || window.location.search).substring(1);

  while ((e = r.exec(q))) {
    hashParams[d(e[1])] = d(e[2]);
  }

  return hashParams;
};

// 获取首字缩写
export const getNameAbbr = (name: string) => {
  if (!name) return '';
  return name[0].toLocaleUpperCase();
};
